<template>
    <div class="crmappBusinessContiner">
        <div class="crmappBusinessContiner-contract">
            <div class="crmappBusinessContiner-contract-text">欢迎您使用我们的产品和服务！我们非常重视您的隐私保护和个人信息保护。本隐私政策适用于您对平台的访问和使用留存的信息。</div>
            <div class="crmappBusinessContiner-contract-sort-title">引 言</div>
            <div class="crmappBusinessContiner-contract-text">
                我们尽量以更清晰、更容易被您理解的方式展现本隐私政策，从而希望能够真实地传达我们希望向您传达的信息，并希望您在向我们提供某些信息（其中很可能包括您的个人信息）以及允许我们处理并分享某些信息之前，能够清晰地了解这些信息收集的目的、可能的用途以及其他方面的内容。为了便于您阅读及理解，我们将专门术语进行了定义，请参见本隐私政策“附录1：定义”来了解这些定义的具体内容。
            </div>
            <div class="crmappBusinessContiner-contract-text">
                本隐私政策适用于平台平台（范围详见附录1：定义）所有产品和服务。如某款产品有单独的隐私政策，则该产品的隐私政策将优先适用。该产品隐私政策未涵盖的内容，以本隐私政策内容为准。</div>
            <div class="crmappBusinessContiner-contract-text">
                本隐私政策旨在帮助您了解我们会收集哪些数据、为什么收集这些数据，会利用这些数据做些什么及如何保护这些数据。若您使用平台的服务，即表示您认同我们在本政策中所述内容。在将您的信息用于本隐私权政策未涵盖的用途时，我们会事先征求您的同意。
            </div>
            <div class="crmappBusinessContiner-contract-text">
                此外，我们在产品设计的过程中及最终的呈现和用户体验环节，将尽可能地为您控制个人信息、保护个人隐私提供更为便捷的方式。例如：您可以在【搜索隐私设置】中方便地对搜索记录进行开关设置，如您关闭搜索记录，我们将不再继续记录您的搜索记录，这可能会导致您的搜索效率和搜索内容的个性化程度降低。您还可以通过【查阅/清理搜索框历史展现词】实现在您的服务界面内查阅、清理您的搜索框历史词。通过此功能，您可以查看您账户内的历史搜索词。当您的账户与他人共享时，您可以方便的清理搜索词在服务界面内的展现。
            </div>
            <div class="crmappBusinessContiner-contract-text">本隐私政策将帮助您了解以下内容：</div>
            <div class="crmappBusinessContiner-contract-text">1.我们如何收集和使用您的个人信息</div>
            <div class="crmappBusinessContiner-contract-text">2.我们如何使用 Cookie 和同类技术</div>
            <div class="crmappBusinessContiner-contract-text">3.我们如何共享、转让、公开披露您的个人信息</div>
            <div class="crmappBusinessContiner-contract-text">4.我们如何保存及保护您的个人信息</div>
            <div class="crmappBusinessContiner-contract-text">5.您的权利</div>
            <div class="crmappBusinessContiner-contract-text">7.您的个人信息如何跨境转移</div>
            <div class="crmappBusinessContiner-contract-text">8.隐私政策的修订</div>
            <div class="crmappBusinessContiner-contract-text">9.如何联系我们</div>
            <div class="crmappBusinessContiner-contract-text">
                我们深知个人信息对您的重要性，也深知为您的信息提供有效保护是我们业务健康可持续发展的基石。感谢您对平台平台的使用和信任！我们致力于维持您对我们的信任，恪守适用法律和我们对您的承诺，尽全力保证您的个人信息安全和合理使用。同时，我们郑重承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
            </div>
            <div class="crmappBusinessContiner-contract-text">一、我们如何收集和使用您的个人信息</div>
            <div class="crmappBusinessContiner-contract-text">平台仅会出于本隐私政策所述的以下目的，收集和使用您的个人信息：</div>
            <div class="crmappBusinessContiner-contract-text">一. 帮助您成为我们的注册用户</div>
            <div class="crmappBusinessContiner-contract-text">
                您注册平台帐号时须至少向我们提供帐号名称、手机号码及或电子邮箱，并创建密码。如果您仅需使用浏览、搜索等基本服务，您不需要注册成为我们的用户及提供上述信息。</div>
            <div class="crmappBusinessContiner-contract-text">
                您提供的上述信息，将在您使用平台产品和服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除上述信息或对您的个人信息进行匿名化处理，法律法规另有规定的除外。</div>
            <div class="crmappBusinessContiner-contract-text">二. 向您提供产品和服务</div>
            <div class="crmappBusinessContiner-contract-text">1. 您向我们提供的信息</div>
            <div class="crmappBusinessContiner-contract-text">
                您使用我们的特定产品和服务时，为满足向您提供产品和服务之目的，除注册时提供的信息外，您可能还需要进一步向我们提供与上述产品和服务的功能相关的信息（例如您的真实姓名、性别、出生日期、身份证号码等），为了验证您提供信息的准确性和完整性，或保障您的信息安全，我们会与合法留存您的信息的国家机关、金融机构、企事业单位进行核对。如果您不使用特定产品和服务，则无需提供相关信息。
            </div>
            <div class="crmappBusinessContiner-contract-text">
                我们还可能会记录您在使用我们的产品和/或服务时提供、形成或留存的信息。例如您在使用平台搜索时输入的搜索关键词信息和点击的链接，您参与其他产品运营活动时提交的信息。您有权选择不提供前述信息，但这将导致您可能无法使用特定服务或功能，或者无法达到相关服务拟达到的效果。
            </div>
            <div class="crmappBusinessContiner-contract-text">2. 我们在您使用服务过程中收集的信息</div>
            <div class="crmappBusinessContiner-contract-text">设备信息</div>
            <div class="crmappBusinessContiner-contract-text">
                为了提供更好的产品和/或服务并改善用户体验，我们会收集设备属性信息（例如您的硬件型号、操作系统版本、设备配置、唯一设备标识符、国际移动设备身份码IMEI、网络设备硬件地址MAC、广告标识符IDFA等），设备连接信息（浏览器的类型、电信运营商、使用的语言）以及设备状态信息（例如设备传感器数据，设备应用安装列表）。对于从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为您提供一致的服务。我们可能会将您的设备信息或电话号码与您的平台帐户相关联。
            </div>
            <div class="crmappBusinessContiner-contract-text">日志信息</div>
            <div class="crmappBusinessContiner-contract-text">
                当您使用产品和服务时，我们的服务器会自动记录一些信息，例如您对我们的产品和/或服务的使用情况、IP地址、所访问服务的URL、浏览器的类型和使用的语言、下载、安装或使用移动应用和软件的信息、与通讯软件通讯的信息以及访问服务的日期、时间、时长等。
            </div>
            <div class="crmappBusinessContiner-contract-text">唯一应用程序编号</div>
            <div class="crmappBusinessContiner-contract-text">
                某些产品和服务包含唯一应用程序编号，当您安装、激活、更新、卸载相关产品和服务或当这些产品和服务定期与平台通信（例如软件的更新）时，系统会将此编号以及与安装相关的信息（例如操作系统类型和应用程序版本号）发送给平台。
            </div>
            <div class="crmappBusinessContiner-contract-text">3.我们通过间接获得方式收集到的您的个人信息</div>
            <div class="crmappBusinessContiner-contract-text">
                当您通过我们产品或服务使用平台关联方、合作方服务时，您同意我们根据实际业务及合作需要从我们关联方、合作方处接收、使用、汇总、分析经您授权同意其向我们提供的您的个人信息。</div>
            <div class="crmappBusinessContiner-contract-text">三. 与您沟通</div>
            <div class="crmappBusinessContiner-contract-text">
                我们会利用收集的信息（例如您的手机号码、电子邮件地址）直接与您沟通或互动。例如，如果我们检测到可疑活动（例如尝试从不同于平常的位置登录您的平台帐号）时，可能会向您发送通知。或者，我们可能与您联系，让您了解平台服务即将发生的变化或改进，邀请您参加新产品的体验等。
            </div>
            <div class="crmappBusinessContiner-contract-text">
                为了让您有更好的体验、改善我们的服务或经您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某些服务所收集的信息用于我们的其他服务。例如，将您在使用我们某项服务时的信息，用于另一项服务中向您展示个性化的内容或广告、用于用户研究分析与统计等服务。
            </div>
            <div class="crmappBusinessContiner-contract-text">四. 为您展示和推送定制内容</div>
            <div class="crmappBusinessContiner-contract-text">通过使用收集的信息，我们会得以向您提供定制内容，例如向您展现或推荐相关程度更高（而非普遍推送）的搜索结果、信息流或者广告/推广信息结果。</div>
            <div class="crmappBusinessContiner-contract-text">
                为了让您有更好的体验、改善我们的服务或经您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某些服务所收集的信息用于我们的其他服务。例如，将您在使用我们某项服务时的信息，用于另一项服务中向您展示个性化的内容或广告、用于用户研究分析与统计等服务。
            </div>
            <div class="crmappBusinessContiner-contract-text">五. 为您提供安全保障</div>
            <div class="crmappBusinessContiner-contract-text">
                为提高您使用我们与平台关联方、合作方提供的产品和服务的安全性，我们可能使用您的信息用于身份验证、客户服务、安全防范、诈骗监测、信贷分析等，以预防、发现、调查欺诈、危害安全、非法或违反与我们的协议、政策或规则的行为，以保护您、我们的其他用户、我们或平台关联方、合作方及社会公众的合法权益。
            </div>
            <div class="crmappBusinessContiner-contract-text">六. 改善我们的产品和服务，并开展内部审计、数据分析和研究</div>
            <div class="crmappBusinessContiner-contract-text">
                我们使用收集的信息来提供并改进我们及平台关联方、合作方提供的产品和服务，并进行必要的业务运营，例如运营产品或提供服务，评估、维护和改进产品和服务的性能，开发新的产品和服务、提供客户支持等。
            </div>
            <div class="crmappBusinessContiner-contract-text">
                为改进我们及平台关联方、合作方的产品和服务，我们也可能会对产品使用情况进行统计和分析。同时，平台可能会与公众共享这些统计信息，以展示我们服务的整体使用趋势，但这些统计信息将不会包含您的任何身份识别信息。
            </div>
            <div class="crmappBusinessContiner-contract-text">
                我们会将所收集到的信息用于大数据分析。例如，我们将收集到的信息用于分析形成不包含任何个人信息的统计类产品。我们可能对外公开并与我们的合作伙伴分享经统计加工后不含身份识别内容的大数据分析信息。
            </div>
            <div class="crmappBusinessContiner-contract-text">我们如何保存及保护您的个人信息</div>
            <div class="crmappBusinessContiner-contract-text">一. 保存期限</div>
            <div class="crmappBusinessContiner-contract-text">
                您在使用平台产品及服务期间，我们将持续为您保存您的个人信息。如果您注销帐户或主动删除上述信息，我们将依据网络安全法等法律法规规定保存您的信息。在您注销帐户或主动删除上述信息后，我们不会再对您的个人信息进行商业化使用，但我们可能会对您的个人信息进行匿名化处理后使用。
            </div>
            <div class="crmappBusinessContiner-contract-text">二. 保存地域</div>
            <div class="crmappBusinessContiner-contract-text">您的个人信息均储存于中华人民共和国境内。</div>
            <div class="crmappBusinessContiner-contract-text">二. 安全措施</div>
            <div class="crmappBusinessContiner-contract-text">1. 我们会以业界成熟的安全标准和规范收集、使用、存储和传输用户信息，并通过用户协议和隐私政策告知您相关信息的使用目的和范围。</div>
            <div class="crmappBusinessContiner-contract-text">2.
                我们非常重视信息安全。我们建立了完善的信息安全管理制度和内部安全事件处置机制等。我们会采取符合业界标准的合理可行的安全措施和技术手段存储和保护您的个人信息，以防止您的信息丢失、遭到被未经授权的访问、公开披露、使用、修改、毁损、丢失或泄漏。我们会采取一切合理可行的措施，保护您的个人信息。我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击。
            </div>
            <div class="crmappBusinessContiner-contract-text">3.
                我们会对员工进行数据安全的意识培养和安全能力的培训和考核，加强员工对于保护个人信息重要性的认识。我们部署访问控制机制，对处理个人信息的员工进行身份认证及权限控制，并会与接触您个人信息的员工、合作伙伴签署保密协议，明确岗位职责及行为准则，确保只有授权人员才可访问个人信息。若有违反保密协议的行为，会被追究相关责任。
            </div>
            <div class="crmappBusinessContiner-contract-text">4.
                我们提醒您注意，互联网并非绝对安全的环境，当您通过电子邮件、短信等与其他用户交互信息时，不确定第三方软件对信息的传递是否完全加密，请注意确保您个人信息的安全，我们建议您不要通过此类方式发送个人信息，以免个人信息泄露。请使用复杂密码，协助我们保证您的账号以及个人信息安全。
            </div>
            <div class="crmappBusinessContiner-contract-text">
                根据我们的安全管理制度，个人信息泄露、毁损或丢失事件被列为最特大安全事件，一经发生将启动公司最高级别的紧急预案，由【安全部、政府关系部、法务部】等多个部门组成联合应急响应小组处理。
            </div>
            <div class="crmappBusinessContiner-contract-text">三. 安全事件通知</div>
            <div class="crmappBusinessContiner-contract-text">1.
                我们会制定网络安全事件应急预案，及时处置系统漏洞、计算机病毒、网络攻击、网络侵入等安全风险，在发生危害网络安全的事件时，我们会立即启动应急预案，采取相应的补救措施，并按照规定向有关主管部门报告。
            </div>
            <div class="crmappBusinessContiner-contract-text">2.
                在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处理措施、您可自主防范和降低的风险的建议、对您的补救措施等。我们将及时将事件相关情况以站内通知、短信通知、电话、邮件等您预留的联系方式告知您，难以逐一告知时我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
            </div>
            <div class="crmappBusinessContiner-contract-text">您的权利</div>
            <div class="crmappBusinessContiner-contract-text">按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</div>
            <div class="crmappBusinessContiner-contract-text">一. 访问您的个人信息</div>
            <div class="crmappBusinessContiner-contract-text">您有权访问您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问您的个人信息：</div>
            <div class="crmappBusinessContiner-contract-text">账户信息——如果您希望访问或编辑您的账户中的个人基本资料信息、联系方式信息、更改您的密码、添加安全信息、进行账户关联、身份认证等，您可以通过产品
                【账号与安全】执行此类操作。</div>
            <div class="crmappBusinessContiner-contract-text">如果您无法通过上述链接访问该等个人信息，您可以通过个人信息保护问题反馈，随时与我们联系。</div>
            <div class="crmappBusinessContiner-contract-text">您在使用我们的产品和服务过程中产生的其他个人信息，只要我们不需要过多投入，我们会向您提供。如果您想行使数据访问权，请通过个人信息保护问题反馈与我们联系。
            </div>
            <div class="crmappBusinessContiner-contract-text">二. 更正您的个人信息</div>
            <div class="crmappBusinessContiner-contract-text">
                您发现我们处理的关于您的个人信息有错误时，您有权对错误或不完整的信息作出更正或更新，您可以通过个人信息保护问题反馈随时与我们联系。为保障安全，我们将在您行使更正权前对您的身份进行验证。
            </div>
            <div class="crmappBusinessContiner-contract-text">三. 删除您的个人信息</div>
            <div class="crmappBusinessContiner-contract-text">在以下情形中，您可以向我们提出删除个人信息的请求，您可以通过个人信息保护问题反馈随时与我们联系：</div>
            <div class="crmappBusinessContiner-contract-text">1. 如果我们违法法律法规或与您的约定收集、使用、与他人共享或转让您的个人信息；</div>
            <div class="crmappBusinessContiner-contract-text">2. 如果我们违反法律法规规定或与您的约定，公开披露您的个人信息，您有权要求我们立即停止公开披露的行为，并发布通知要求相关接收方删除相应的信息。</div>
            <div class="crmappBusinessContiner-contract-text">当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。 </div>
            <div class="crmappBusinessContiner-contract-text">四. 改变您授权同意的范围</div>
            <div class="crmappBusinessContiner-contract-text">如您想改变授权范围，您可通过平台平台产品的隐私设置修改授权范围，例如：</div>
            <div class="crmappBusinessContiner-contract-text">1. 您可以可以在【搜索隐私设置】中方便地对搜索记录进行开关设置。</div>
            <div class="crmappBusinessContiner-contract-text">2.
                当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理。
            </div>
            <div class="crmappBusinessContiner-contract-text">五. 响应您的上述请求</div>
            <div class="crmappBusinessContiner-contract-text">为保障安全，您需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</div>
            <div class="crmappBusinessContiner-contract-text">
                对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
            </div>
            <div class="crmappBusinessContiner-contract-text">在以下情形中，按照法律法规要求，我们将无法响应您的上述请求：</div>
            <div class="crmappBusinessContiner-contract-text">1. 与国家安全、国防安全直接相关的；</div>
            <div class="crmappBusinessContiner-contract-text">2. 与公共安全、公共卫生、重大公共利益直接相关的；</div>
            <div class="crmappBusinessContiner-contract-text">3. 与犯罪侦查、起诉、审判和执行判决等直接相关的；</div>
            <div class="crmappBusinessContiner-contract-text">4. 我们有充分证据表明您存在主观恶意或滥用权利的（如您的请求将危害公共安全和其他人合法权益，或您的请求超出了一般技术手段和商业成本可覆盖的范围）；
            </div>
            <div class="crmappBusinessContiner-contract-text">5. 响应个人信息主体的请求将导致您或其他个人、组织的合法权益受到严重损害的；</div>
            <div class="crmappBusinessContiner-contract-text">本隐私政策所指的重大变更包括但不限于：</div>
            <div class="crmappBusinessContiner-contract-text">1. 我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</div>
            <div class="crmappBusinessContiner-contract-text">2. 个人信息共享、转让或公开披露的主要对象发生变化；</div>
            <div class="crmappBusinessContiner-contract-text">3. 您参与个人信息处理方面的权利及其行使方式发生重大变化；</div>
            <div class="crmappBusinessContiner-contract-text">4. 其他可能对您的个人信息权益产生重大影响的变化时。</div>
            <div class="crmappBusinessContiner-contract-text">如何联系我们</div>
            <div class="crmappBusinessContiner-contract-text">如您对本隐私政策有任何意见或建议，可通过service@yuanshanbao.com联系我们。</div>
            <div class="crmappBusinessContiner-contract-text">
                为保障我们高效处理您的问题并及时向您反馈，需要您提交身份证明、有效联系方式和书面请求及相关证据，我们会在验证您的身份后处理您的请求。一般情况下，我们将在【7】天内回复。</div>
            <div class="crmappBusinessContiner-contract-text">
                如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求结局方案：向【公司注册所地有管辖权的法院提起诉讼】。</div>
            <div class="crmappBusinessContiner-contract-text">附录1：定义</div>
            <div class="crmappBusinessContiner-contract-text">本隐私政策中使用的特定词语，具有如下含义：</div>
            <div class="crmappBusinessContiner-contract-text">1. “我们”或“平台方，这里是指推咖联盟。</div>
            <div class="crmappBusinessContiner-contract-text">2. “您”，指使用我们的产品和服务的注册用户以及收费服务的购买方。</div>
            <div class="crmappBusinessContiner-contract-text">3. “平台平台”，指平台网站（http://www. 51tuika.com）。</div>
            <div class="crmappBusinessContiner-contract-text">4. “平台关联方、合作方”，指我们的关联公司、合作伙伴及其他受信任的第三方供应商、服务商及代理商。</div>
            <div class="crmappBusinessContiner-contract-text">5. “我们的产品和服务”或“平台平台产品和服务”，指平台旗下提供的保险产品营销服务。</div>
            <div class="crmappBusinessContiner-contract-text">6.
                “个人信息”，指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。个人信息包括个人基本信息、个人身份信息、个人生物识别信息、网络身份标识信息、个人健康生理信息、个人教育工作信息、个人财产信息、个人通信信息、联系人信息、个人上网记录、个人常用设备信息、个人位置信息等。为免疑义，个人信息包括但不限于个人敏感信息。
            </div>
            <div class="crmappBusinessContiner-contract-text">7. “个人信息主体”，指个人信息所标识的自然人。</div>
            <div class="crmappBusinessContiner-contract-text">8.
                “个人敏感信息”，指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。个人敏感信息包括个人财产信息、个人健康生理信息、个人生物识别信息、个人身份信息、网络身份标识信息等。
            </div>
            <div class="crmappBusinessContiner-contract-text">9. “去标识化”，指通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体的过程。</div>
            <div class="crmappBusinessContiner-contract-text">10. “匿名化”，指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。</div>
            <div class="crmappBusinessContiner-contract-text">11. “中国”或“中国境内”，指中华人民共和国大陆地区，仅为本隐私政策之目的，不包含香港特别行政区、澳门特别行政区和台湾地区。</div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'contract',
    props: {
        userA: {//甲方
            type:String,
            default:''
        },
        popuTime:{//协议时间
            type:String,
            default:''
        },
        readContract: {
            type:Boolean,
            default:true
        },
        showContract: {
            type:Boolean,
            default:true
        }
    },
    data(){
        return{
            showView:this.showContract
        }
    },
    watch:{
        showView(val){
            this.$emit('update:showContract',val);
        },
        showContract(val){
            this.showView = val;
        }
    },
    methods: {
        showContractClick() {
            this.$emit('showContractClick');
        }
    }
}
</script>

<style lang="less">
.crmappBusinessContiner{
    &-contract{
        margin: 0px 10px 10px 10px;
        overflow-y: auto;
        color: gray !important;
        &-text{
            font-size: 10px;
            margin-top: 5px;
            text-indent: 2em;
        }
        &-sort-title{
            margin-top: 5px;
            margin-bottom: 5px;
            font-size: 14px;
            text-align: center;
        }
    }
}

</style>
